import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var TopologyValidationError = /*#__PURE__*/function () {
  function TopologyValidationError() {
    _classCallCheck(this, TopologyValidationError);
    TopologyValidationError.constructor_.apply(this, arguments);
  }
  _createClass(TopologyValidationError, [{
    key: "getErrorType",
    value: function getErrorType() {
      return this._errorType;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return TopologyValidationError.errMsg[this._errorType];
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._pt;
    }
  }, {
    key: "toString",
    value: function toString() {
      var locStr = '';
      if (this._pt !== null) locStr = ' at or near point ' + this._pt;
      return this.getMessage() + locStr;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._errorType = null;
      this._pt = null;
      if (arguments.length === 1) {
        var errorType = arguments[0];
        TopologyValidationError.constructor_.call(this, errorType, null);
      } else if (arguments.length === 2) {
        var _errorType = arguments[0],
          pt = arguments[1];
        this._errorType = _errorType;
        if (pt !== null) this._pt = pt.copy();
      }
    }
  }]);
  return TopologyValidationError;
}();
export { TopologyValidationError as default };
TopologyValidationError.ERROR = 0;
TopologyValidationError.REPEATED_POINT = 1;
TopologyValidationError.HOLE_OUTSIDE_SHELL = 2;
TopologyValidationError.NESTED_HOLES = 3;
TopologyValidationError.DISCONNECTED_INTERIOR = 4;
TopologyValidationError.SELF_INTERSECTION = 5;
TopologyValidationError.RING_SELF_INTERSECTION = 6;
TopologyValidationError.NESTED_SHELLS = 7;
TopologyValidationError.DUPLICATE_RINGS = 8;
TopologyValidationError.TOO_FEW_POINTS = 9;
TopologyValidationError.INVALID_COORDINATE = 10;
TopologyValidationError.RING_NOT_CLOSED = 11;
TopologyValidationError.errMsg = ['Topology Validation Error', 'Repeated Point', 'Hole lies outside shell', 'Holes are nested', 'Interior is disconnected', 'Self-intersection', 'Ring Self-intersection', 'Nested shells', 'Duplicate Rings', 'Too few distinct points in geometry component', 'Invalid Coordinate', 'Ring is not closed'];